module.exports = __webpack_public_path__ + "static/roller-37575eb35f52a5bfc36a3eceb2692646.jpg";